import { render, staticRenderFns } from "./RoleDistribution.vue?vue&type=template&id=386bd542&scoped=true&"
import script from "./RoleDistribution.vue?vue&type=script&lang=js&"
export * from "./RoleDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386bd542",
  null
  
)

export default component.exports